import PillOrder from './PillOrder';

export default PillOrder;
